<div class="tab-content">
  <div class="table-view">
    <!-- Table starts -->
    <p-table
      #contactsTable
      [value]="employee"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      exportFilename="CustomerContactList"
      (onPage)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{totalItems}}"
      [lazy]="true"
      [loading]="isLoading"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="table-options">
            <div class="pull-right">
              <kuba-export
                [reportData]="contactsTable.filteredValue || contactsTable.value"
                [additionalData]="additionalData"
                [filters]="{
                  name: nameFilter,
                  department: departmentFilter,
                  businessId: businessFilter,
                  email: emailFilter,
                  mobile: mobileFilter,
                  withUserOnly: false,
                  sortField: 'Name',
                  sortOrder: 'ASC'
                }"
                [exportAllData]="true"
                [getAllDataFn]="getAllEmployeesForExport"
                (loading)="$event ? showExportLoader() : hideExportLoader()"
              ></kuba-export>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Name">{{ "EMPLOYEE_NAME" | translate }}</th>
          <th pSortableColumn="DepartmentName">{{ "DEPARTMENT" | translate }}</th>
          <th pSortableColumn="BusinessName">{{ "BUSINESS" | translate }}</th>
          <th pSortableColumn="Email">{{ "EMAIL" | translate }}</th>
          <th pSortableColumn="Mobile">{{ "MOBILE" | translate }}</th>
        </tr>
        <tr>
          <th>
            <input pInputText type="text" [(ngModel)]="nameFilter" (input)="onFilterChange()" class="p-column-filter" />
          </th>
          <th>
            <input pInputText type="text" [(ngModel)]="departmentFilter" (input)="onFilterChange()" class="p-column-filter" />
          </th>
          <th>
            <p-select
              [options]="businesses"
              [(ngModel)]="businessFilter"
              (onChange)="onBusinessChanged($event, ed)"
              #ed
              styleClass="p-column-filter"
              placeholder="{{ 'SELECT' | translate }}"
              [showClear]="true"
              [filter]="true"
              optionLabel="label"
              optionValue="value"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th>
            <input pInputText type="text" [(ngModel)]="emailFilter" (input)="onFilterChange()" class="p-column-filter" />
          </th>
          <th>
            <input pInputText type="text" [(ngModel)]="mobileFilter" (input)="onFilterChange()" class="p-column-filter" />
          </th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-employee>
        <tr>
          <td>
            <span>
              <a href="javascript:void(0);" (click)="openEmployeeInNewWindow(employee)">{{ employee.Name }}</a>
            </span>
          </td>
          <td>
            <span>{{ employee.DepartmentName }}</span>
          </td>
          <td>
            <span>
              <a href="javascript:void(0);" (click)="openBusinessInNewWindow(employee)">{{ employee.BusinessName }}</a>
            </span>
          </td>
          <td>
            <span>{{ employee.Email }}</span>
          </td>
          <td>
            <span>{{ employee.Mobile }}</span>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="5">{{ "NO_RECORDS_FOUND" | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table ends -->
  </div>
</div>
<export-progress-dialog [visible]="exportInProgress"></export-progress-dialog>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>

